import {Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography} from "@material-ui/core";
import AntDataGrid from "../../shared/components/AntDataGrid";
import useStatistic from "../../hooks/useStatistic";
import {epochToDate} from "../../shared/functions/toDateTime";

const THEAD = [
    {
        dataIndex: 'period', title: "Period",
        render: (_, record) => (
            <Typography variant={'body1'}>
                {`${epochToDate(record?.PeriodeDeb)} to ${epochToDate(record?.PeriodeEnd)}`}
            </Typography>
        )
    },
    {dataIndex: 'Initial_Stok', title: "Init. Stock"},
    {dataIndex: 'Qty_Enter', title: "Qty Enter"},
    {dataIndex: 'Qty_Out', title: "Qty Out"},
    {dataIndex: 'Qty_Final', title: "Qty Final"},
]

export default function ItemStat({selected, open, onClose}) {
    const {loading, list} = useStatistic(selected)

    return (
        <Dialog open={open} onClose={onClose}>

            <DialogTitle>
                Statistique
            </DialogTitle>

            <DialogContent>
                <AntDataGrid
                    data={list.map(({key,one, id}) => ({...one, id}))}
                    isLoading={loading}
                    columns={THEAD}
                />
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>
                    Fermer
                </Button>

            </DialogActions>
        </Dialog>
    )
}